module.exports = __webpack_public_path__ + "b0722ac5f736fd6c4fdcc157c40c7c64.svg";